<template>
    <div>
        <input type="file" ref="fileInput" @change="handleFileUpload" accept="image/*" style="display: none" />
    </div>
</template>

<script>
import { EventBus } from '@/event-bus';
export default {
    mounted () {
        console.log('ImageMenu')
        this.$refs.fileInput.click();
    },

    methods: {
        handleFileUpload(event) {
            const file = event.target.files[0];
            if (file) {
                const id = Math.random().toString(36).substr(2, 9)
                EventBus.$emit('postcreator/uploadFile',null ,file, true, id, ()=>{
                    this.$emit('addSticker','image', {
                        data: {
                            idFile: id
                        }
                    })
                })
            }
        }
    }
}
</script>
